<ng-container *ngIf="context$ | async as context">
  <!-- Image Mobile-->
  <ng-container *ifScreenSize="screenSize.Mobile">
    <div class="loyalty-details-image card border-0 overflow-hidden p-0 fgbcl-rewards-image">
      <img
        class="card-img"
        src="{{ context.item.ImageURL | contentImage: '7' : 'marketplace' }}"
        [alt]="context.item.DisplayName"
        draggable="false"
      />
      <fgbcl-social-share-modal
        shareType="rewards"
        [itemId]="itemId"
        urlPage="rewards/marketplace/details"
        [loyaltyCategoryType]="loyaltyCategoryType"
      ></fgbcl-social-share-modal>
    </div>
  </ng-container>
  <div class="container">
    @if (context.item) {
      <div class="d-block d-lg-flex">
        <!-- Image Desktop -->
        <ng-container *ifScreenSize="screenSize.Desktop">
          <div class="loyalty-details-image card border-0 p-0" data-version="2">
            <img
              class="card-img"
              src="{{ context.item.ImageURL | contentImage: '7' : 'marketplace' }}"
              [alt]="context.item.DisplayName"
              draggable="false"
            />
            <fgbcl-social-share-modal
              shareType="rewards"
              [itemId]="itemId"
              urlPage="rewards/marketplace/details"
              [loyaltyCategoryType]="loyaltyCategoryType"
            ></fgbcl-social-share-modal>
          </div>
        </ng-container>
        <div class="loyalty-details">
          <!--Sponsor-->
          <ng-container *ngIf="context.item?.Sponsor?.SponsorImage">
            <div class="rewards-details-sponsor">
              <span class="rewards-details-sponsor-text"> {{ context.item?.Sponsor?.SponsorText }} </span>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="{{ context.item?.Sponsor?.SponsorLink }}"
                [attr.aria-label]="
                  (context.item?.Sponsor?.SponsorText || '') + ' (' + ('fgbcl.accessibility.opens.new.tab' | translate) + ')'
                "
              >
                <img
                  src="{{ context.item?.Sponsor?.SponsorImage | contentImage: '7' : 'marketplace' }}"
                  [alt]="context.item?.Sponsor?.SponsorText"
                />
              </a>
            </div>
          </ng-container>
          @if (context.item.Status !== marketplaceStatus.LimitReached) {
            <!-- Stock -->
            @if (context.stock > 0 && context.stock <= 10) {
              <div class="rewards-item-panel-status text-rewards-danger" role="status" aria-live="polite">
                <ng-container *ngIf="context.stock >= 0 && context.stock <= 5">
                  <span class="item-count me-1">{{ context.stock }}</span>
                </ng-container>
                <!-- Stock Remaining -->
                @if (context.stock > 0 && context.stock <= 5) {
                  <span class="item-state">{{ 'marketplace.panel.remaining.stock' | translate }}</span>
                } @else if (context.stock > 5 && context.stock <= 10) {
                  <span class="item-state">{{ 'marketplace.limited.stock' | translate }}</span>
                }
              </div>
            }
          }
          <h2 class="rewards-item-name" id="header-name">
            {{ context.item.DisplayName }}
          </h2>
          <ng-container *ngIf="!context.isMerchantItem && !context.isEcashItem">
            <div class="marketplace-details-points">
              <span class="rewards-item-details" id="points-value" *ngIf="context.item.PointValue > 0">{{
                context.item.PointValue | FortressCurrencyPipe: 'PTS'
              }}</span>
              <!--Display text if value is 0-->
              <span *ngIf="context.item.PointValue == 0" class="rewards-item-details" id="points-value">{{
                'fgbcl.marketplace.item.free' | translate
              }}</span>
            </div>
          </ng-container>
          @if (context.item.IsOwnWindow) {
            <fgbcl-countdown
              [endDateTime]="context.item.ItemEndDate"
              [showTimer]="false"
              (complete)="onMarketplaceEnd()"
            ></fgbcl-countdown>
          }
          <!-- Merchant-->
          <ng-container *ngIf="context.isMerchantItem">
            <div class="marketplace-merchant">
              <span class="rewards-item-details" id="merchant-value">{{
                context.item.MerchantValue / 100 | FortressCurrencyPipe
              }}</span>
            </div>
          </ng-container>
          <!-- Ecash -->
          <ng-container *ngIf="context.isEcashItem">
            <div class="marketplace-ecash">
              <span class="rewards-item-details" id="ecash-value">{{
                context.item.EcashValue / 100 | FortressCurrencyPipe
              }}</span>
            </div>
          </ng-container>
          @if (context.isDisabled) {
            @if (!context.item.DisableManualEntry) {
              <ng-container *ngTemplateOutlet="disabledTemplate; context: { $implicit: context.item }"></ng-container>
            }
          } @else {
            @if (marketplaceDetailForm) {
              <div
                class="marketplace-detail-form"
                [formGroup]="marketplaceDetailForm"
                [class.form-invalid]="marketplaceDetailForm?.get('quantity').disabled"
              >
                @if (context.isAttributeItem || context.item.CustomFields?.length > 0 || context.item.ShowTermsAndConditions) {
                  <div class="form-group">
                    <!-- Attribute Field -->
                    @if (context.isAttributeItem) {
                      <div class="attribute-fields">
                        <fgbcl-attribute-field
                          [attributeMappings]="context.item.AttributeMappings"
                          [attributes]="context.item.Attributes"
                          formControlName="attribute"
                          (attributeChange)="onAttributeChange(context, $event)"
                        />
                      </div>
                    }
                    <!-- Custom Fields -->
                    @if (context.item.CustomFields?.length > 0) {
                      <div class="custom-fields" formArrayName="customFields">
                        @for (field of context.item.CustomFields; track field.CustomFieldId; let i = $index) {
                          <div [formGroup]="marketplaceDetailForm.get('customFields')?.controls[i]">
                            <fgbcl-custom-field [field]="field" formControlName="customFieldValue" />
                          </div>
                        }
                      </div>
                    }
                    <!--Terms and Condtions Checkbox-->
                    <div *ngIf="context.item.ShowTermsAndConditions">
                      <div
                        class="form-check rewards-accept-terms-checkbox"
                        data-version="2"
                        [ngClass]="
                          marketplaceDetailForm.get('acceptTerms')?.value ? 'rewards-terms-checked' : 'rewards-terms-unchecked'
                        "
                      >
                        <input
                          formControlName="acceptTerms"
                          class="form-check-input"
                          id="accept-terms"
                          type="checkbox"
                          (change)="onAcceptTermsChange(marketplaceDetailForm.get('acceptTerms')?.value)"
                        />
                        <label
                          [ngClass]="
                            marketplaceDetailForm.get('acceptTerms')?.value ? 'rewards-terms-checked' : 'rewards-terms-unchecked'
                          "
                          class="rewards-terms-label ms-1"
                          for="accept-terms"
                        >
                          {{ 'marketplace.terms.accept' | translate }}
                        </label>
                      </div>
                    </div>
                  </div>
                }
                <!-- Action Buttons -->
                <div class="rewards-button-background">
                  <div class="rewards-button-container">
                    <div class="rewards-quantity-field-container justify-content-center align-items-center">
                      <fgbcl-quantity-field [minValue]="minQuantity()" [maxValue]="maxQuantity()" formControlName="quantity" />
                    </div>

                    @if (context.action) {
                      <button
                        id="purchase-now-button"
                        [disabled]="isRedeemDisabled"
                        [attr.aria-disabled]="isRedeemDisabled"
                        class="btn btn-rewards-redeem fw-bold text-nowrap"
                        (click)="invokeAction(context.item, context.action)"
                      >
                        {{ context.action?.label | translate }}
                      </button>
                      <ng-container *fgbWebsiteContentFeatureFlag="'feature.flag.cart.show'">
                        <div class="text-end">
                          <button
                            id="desktop-addtocart-button"
                            class="btn btn-marketplace-cart border-0 mt-4 px-2 ms-2 mt-lg-0 d-none d-lg-block"
                            [disabled]="marketplaceDetailForm.get('quantity')?.disabled"
                            (click)="addProductToCart(context)"
                            attr.aria-label="{{ 'cart.add.item.screenreader' | translate }}"
                          >
                            <img src="assets/images/icons/add_shopping_cart.svg" class="basket-icon" alt="" />
                          </button>
                          <button
                            id="mobile-addtocart-button"
                            class="btn btn-marketplace-cart border-0 px-2 ms-2 mt-lg-0 d-lg-none"
                            (click)="addProductToCart(context)"
                            [disabled]="marketplaceDetailForm.get('quantity')?.disabled"
                            attr.aria-label="{{ 'cart.add.item.screenreader' | translate }}"
                          >
                            <img src="assets/images/icons/add_shopping_cart.svg" class="basket-icon" alt="" />
                          </button>
                        </div>
                      </ng-container>
                    }
                  </div>
                </div>

                <!-- Server Side Errors -->
                <fgbcl-errors />
                <div role="alert" class="error-message alert-danger" *ngIf="marketplaceDetailForm?.errors?.itemLimitExceeded">
                  @if (marketplaceDetailForm?.errors?.itemLimitExceeded?.type === 1) {
                    {{
                      'marketplace.error.item.limit.member.exceeded'
                        | translate: { max: marketplaceDetailForm?.errors?.itemLimitExceeded?.limit }
                    }}
                  } @else if (marketplaceDetailForm?.errors?.itemLimitExceeded?.type === 2) {
                    {{
                      'marketplace.error.item.limit.account.exceeded'
                        | translate: { max: marketplaceDetailForm?.errors?.itemLimitExceeded?.limit }
                    }}
                  }
                </div>
                <div role="alert" class="error-message alert-danger" *ngIf="marketplaceDetailForm?.errors?.limitExceeded">
                  {{ 'marketplace.error.item.limit.reached' | translate }}
                </div>
                <div role="alert" class="error-message alert-danger" *ngIf="marketplaceDetailForm?.errors?.maxQuantityExceeded">
                  {{ 'marketplace.error.item.not.enough.points' | translate }}
                </div>
                <div role="alert" class="error-message alert-danger" *ngIf="marketplaceDetailForm?.errors?.cartQuantityExceeded">
                  {{
                    'marketplace.error.item.cart.quantity.exceeded'
                      | translate: { max: marketplaceDetailForm?.errors?.cartQuantityExceeded?.max }
                  }}
                </div>
                <div
                  role="alert"
                  class="error-message alert-danger"
                  *ngIf="marketplaceDetailForm?.get('quantity').hasError('min') && marketplaceDetailForm?.get('quantity').touched"
                >
                  {{ 'marketplace.error.quantity.min' | translate: { min: minQuantity() } }}
                </div>
                <div role="alert" class="error-message alert-danger" *ngIf="marketplaceDetailForm?.errors?.productLimitExceeded">
                  @if (marketplaceDetailForm?.errors?.productLimitExceeded?.type === 1) {
                    {{
                      'marketplace.error.product.limit.member.exceeded'
                        | translate: { max: marketplaceDetailForm?.errors?.productLimitExceeded?.limit }
                    }}
                  } @else if (marketplaceDetailForm?.errors?.productLimitExceeded?.type === 2) {
                    {{
                      'marketplace.error.product.limit.account.exceeded'
                        | translate: { max: marketplaceDetailForm?.errors?.productLimitExceeded?.limit }
                    }}
                  }
                </div>
              </div>
            }
          }
          <!-- Description & Terms Nav -->
          <div class="rewards-details-desc-terms accordion accordion-flush" id="marketplaceDescTerms">
            <div class="accordion-item rewards-accordion-item">
              <div class="accordion-header" id="marketplace-description">
                <button
                  class="accordion-button rewards-item-description-title rewards-accordion-item"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#marketplaceDesc"
                  aria-expanded="true"
                  aria-controls="marketplaceDesc"
                >
                  {{ 'marketplace.item.description' | translate }}
                </button>
              </div>
              <div
                id="marketplaceDesc"
                class="accordion-collapse collapse show"
                data-bs-parent="#marketplaceDescTerms"
                role="region"
                aria-labelledby="marketplace-description"
              >
                <div class="rewards-item-description" [innerHtml]="context.item.DescriptionText | safeHtml"></div>
              </div>
            </div>
            <ng-container *ngIf="context.item.ShowTermsAndConditions">
              <div class="accordion-item rewards-accordion-item">
                <div class="accordion-header" id="marketplace-terms">
                  <button
                    class="accordion-button collapsed rewards-item-terms rewards-accordion-item"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#marketplaceTerms"
                    aria-expanded="false"
                    aria-controls="marketplaceTerms"
                  >
                    {{ 'marketplace.item.tcs' | translate }}
                  </button>
                </div>
                <div
                  id="marketplaceTerms"
                  class="accordion-collapse collapse"
                  data-bs-parent="#marketplaceDescTerms"
                  role="region"
                  aria-labelledby="marketplace-terms"
                >
                  <!--Text T&Cs-->
                  <ng-container *ngIf="context.item.TermsAndConditionsType === TermsAndCondtionsType.Text">
                    <div class="rewards-item-terms-text" [innerHtml]="context.item.TermsAndConditions | safeHtml"></div>
                  </ng-container>
                  <!--URL T&Cs-->
                  <ng-container *ngIf="context.item.TermsAndConditionsType === TermsAndCondtionsType.URL">
                    <a
                      [href]="context.item.TermsAndConditions"
                      target="_blank"
                      rel="noopener noreferrer"
                      class="rewards-item-terms-url"
                      id="link-url"
                      [attr.aria-label]="
                        ('marketplace.item.tcs' | translate) + ' (' + ('fgbcl.accessibility.opens.new.tab' | translate) + ')'
                      "
                      >{{ context.item.TermsAndConditions }}</a
                    >
                  </ng-container>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    }
  </div>
</ng-container>

<!-- Disabled status template -->
<ng-template #disabledTemplate let-item>
  <div class="status-container">
    <div class="reward-disabled-status">
      @switch (item.Status) {
        @case (marketplaceStatus.ComingSoon) {
          <div class="bg-coming-soon reward-status">
            <label role="status">
              {{ 'reward.status.coming.soon' | translate }}
            </label>
            @if (item.RequestTime && item.ItemStartDate) {
              <fgbcl-countdown-v2
                [startDateTime]="item.RequestTime"
                [endDateTime]="item.ItemStartDate"
                (complete)="onComingSoonComplete()"
              >
              </fgbcl-countdown-v2>
            }
          </div>
        }
        @case (marketplaceStatus.ViewableOnly) {
          <div class="bg-item-locked reward-status">
            <label role="status">
              <span class="icon material-icons" aria-hidden="true">lock</span>
              {{ 'reward.status.locked' | translate }}
            </label>
          </div>
        }
        @case (marketplaceStatus.SoldOut) {
          <div class="bg-sold-out reward-status">
            <label role="status">
              {{ 'reward.status.sold.out' | translate }}
            </label>
          </div>
        }
        @case (marketplaceStatus.LimitReached) {
          <div class="bg-limit-reached reward-status" data-version="2">
            <label role="status">{{ 'reward.status.limit.reached' | translate }}</label>
          </div>
        }
        @case (marketplaceStatus.NotEnoughPoints) {
          <div class="bg-not-enough-points reward-status" data-version="2">
            <label role="status">{{ 'reward.status.not.enough.points' | translate }}</label>
          </div>
        }
      }
    </div>
  </div>
</ng-template>
